import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface CheckMobileEmailExistRequestData {
  emailId: string
  mobileNo: string
}

export interface CheckMobileEmailExistRequest
  extends Partial<AxiosRequestConfig> {
  params: CheckMobileEmailExistRequestData
}

export interface CheckMobileEmailExistResponseData extends ResponseData {
  emailExists: boolean
  mobileExists: boolean
  userId?: number
}

export interface CheckMobileEmailExistResponse extends AxiosResponse {
  data: {
    data: CheckMobileEmailExistResponseData
  }
}

export function checkMobileEmailExistAPI(
  { params }: CheckMobileEmailExistRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: `/user/check/mobile-email-exist`,
    params,
  }) as Promise<CheckMobileEmailExistResponse>
}
